import LatestObservationCard from "./LatestObservationCard";
export default LatestObservationCard;
